import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useSSOLoginSettings } from '@/hooks/useSwr';
import { supabase } from '@/utils/backend-auth';

export default function SSOLogin() {
  const { ssoLoginSlug } = useParams();
  const { data: ssoLoginSettings, isLoading: ssoLoginSettingsLoading } =
    useSSOLoginSettings(ssoLoginSlug);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (ssoLoginSettings?.[0] && supabase) {
      supabase.auth
        .signInWithSSO({
          providerId: ssoLoginSettings[0].provider_id,
        })
        .then(({ data, error }) => {
          if (error) {
            setError(error.message);
            return;
          }
          if (data?.url) {
            // redirect the user to the identity provider's authentication flow
            window.location.href = data.url;
          }
        });
    } else if (!ssoLoginSettingsLoading) {
      setError('No SSO login settings found');
    }
  }, [ssoLoginSettings, ssoLoginSettingsLoading]);

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div>
      Redirecting to {ssoLoginSettings?.[0]?.organization_display_name} sso
      provider
    </div>
  );
}
